<p-panel
  [styleClass]="'panel-shadow'"
  [class.ghost]="contentLoading()"
  *ngIf="organisationTypeId == 1"
  [style]="{ 'margin-bottom': '1em' }"
>
  <p-header>
    <div class="panel-header">Service Types</div>
  </p-header>

  <div class="grid-label-value grid-gap-15">
    <div class="">Customer Service Type:</div>
    <div class="ghost-fill value">{{ serviceTypeTask?.taskTypeName }}</div>
    <div>Engineius Service Type:</div>
    <div class="ghost-fill value">{{ serviceTypeTask?.actualTaskTypeName }}</div>
  </div>
  <div class="text-right pt-2">
    <button
      *ngIf="allowServiceTypeEdit()"
      pButton
      (click)="editActualTaskType(serviceTypeTask)"
      label="Change"
      class="ui-button ui-button-secondary"
    ></button>
  </div>
</p-panel>

<p-dialog
  header="Edit Actual Movement Type"
  [(visible)]="showEditActualTaskTypeDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="p-3 style2023">
    <div class="input-group">
      <div class="input-group-prepend group-label white-space-nowrap">Customer Movement Type</div>
      <div class="input-group-item">
        <p-dropdown
          name="taskTypes"
          [options]="taskTypes"
          placeholder="Select task type"
          appendTo="body"
          [style]="{ width: '100%' }"
          [(ngModel)]="taskTypeId"
        ></p-dropdown>
      </div>
    </div>

    <div class="input-group mt-3">
      <div class="input-group-prepend group-label white-space-nowrap">Engineius Movement Type</div>
      <div class="input-group-item">
        <p-dropdown
          name="taskTypes"
          [options]="taskTypes"
          placeholder="Select task type"
          appendTo="body"
          [style]="{ width: '100%' }"
          [(ngModel)]="actualTaskTypeId"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <p-footer class="rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary mr-2"
        (click)="showEditActualTaskTypeDialog = false"
      ></button>

      <button
        type="button"
        class="ui-button ui-button-primary"
        pButton
        (click)="confirmMultiOrderTaskType()"
        label="Save"
        [disabled]="!actualTaskTypeId && !taskTypeId"
      ></button>
    </div>
  </p-footer>
</p-dialog>
